export const MAINTENANCE_QUERY_PARAM = 'maintenance';
export const MAINTENANCE_ERROR_MESSAGE =
  'Patient Portal is undergoing maintenance; please try logging in again later. Reach out to 855 KND BODY if you have any questions';
export const DEACTIVATED_ACCESS_QUERY_PARAM = 'deactivated_access';
export const DEACTIVATED_ACCESS_ERROR_MESSAGE =
  'Your patient portal access has been deactivated at your request. To restore access, please contact the clinic at 855 KND BODY.';
